export const menu1 = [{
  title: 'Solutions',
  link: '#solutions'
}, {
  title: 'Pricing',
  link: '#pricing'
}, {
  title: 'Docs',
  link: '#docs'
}, {
  title: 'More',
  link: '#more'
}]

export const menu2 = [
  {
    title: 'Home',
    link: '/'
  },
  
  {
  title: 'Product',
  link: '/product/0'
},  {
  title: 'Contact US',
  link: '/contactUs/'
}]

export default {
  menu1,
  menu2
}
